import { ViewItemCodesComponent } from '../../../../admin/items/view/components/item-codes.component';
import { ViewRelatedProductsComponent } from '../../../../admin/items/view/components/related-products.component';
import { ViewReorderConfigComponent } from '../../../../admin/items/view/components/reorder-config.component';
import { ViewItemInventoryLevelsComponent } from '../../../../admin/items/view/components/item-inventory-levels.component';
import { ViewItemUsageHistoryComponent } from '../../../../admin/items/view/components/item-usage-history';
import { AssetHierarchicalViewComponent } from '../../../../module/assets/view/components/asset-hierarchical-view/asset-hierarchical-view.component';
import { LineItemsComponent } from '../line-items/line-items.component';
import { ViewWarehouseStockLevelsComponent } from '../../../../admin/warehouse/view/warehouse-stock-levels/view-warehouse-stock-levels.component';
import { SchedulesComponent } from '../../schedules/schedules.component';
import {
  AssetTypeViewFaultCodesComponent,
  AssetTypeViewVariantsComponent,
  AssetViewTypeInspectionChecklistComponent,
} from '../../../../module/asset-types';
import { ContractRecurringJobsComponent } from '../../../../module/contracts/contract-recurring-jobs/contract-recurring-jobs.component';
import { ContractRecurringInvoicesComponent } from '../../../../module/contracts/contract-recurring-invoices/contract-recurring-invoices.component';
import { ContractItemsComponent } from '../../../../module/contracts/contract-items/contract-items.component';
import {
  AssetViewActualFaultsComponent,
  AssetViewVariantComponent,
} from '../../../../module/assets';
import { AssetTypeViewReportFieldsComponent } from '../../../../module/asset-types/shared/view/report-fields/view-report-fields.component';
import { UserSkillsComponent } from '../../../../admin/users/components/input/user-skills/user-skills.component';
import { ViewJobTasksComponent } from '../../../../module/jobs';
import { ResourceLineItemsComponent } from '../../../../module/jobs/resources/resource-line-items.component';
import { JobViewWorkLocationsComponent } from '../../../../module/jobs/project-tasks/view-job-work-locations.component';

/**
 * Contains the appropriate component instance for each custom selector that represents the custom field.
 * Each component should be registered in client/src/app/shared/modules/view.module.ts
 *
 * You should register the component in the following keys
 * - entryComponents - this is used to dynamically resolve components using the ComponentResolverFactory class
 * - declarations - the component should be part of the edit module
 */
export const CUSTOM_FIELD_VIEW_SELECTORS = {
  item_codes: ViewItemCodesComponent,
  reorder_config: ViewReorderConfigComponent,
  related_products: ViewRelatedProductsComponent,
  item_inventory_levels: ViewItemInventoryLevelsComponent,
  item_usage_history: ViewItemUsageHistoryComponent,
  hierarchical_view: AssetHierarchicalViewComponent,
  work_order_items: LineItemsComponent,
  schedule: SchedulesComponent,
  asset_type_variants: AssetTypeViewVariantsComponent,
  asset_type_fault_codes: AssetTypeViewFaultCodesComponent,
  asset_type_checklists: AssetViewTypeInspectionChecklistComponent,
  asset_type_reports: AssetTypeViewReportFieldsComponent,
  asset_actual_faults: AssetViewActualFaultsComponent,
  contract_recurring_jobs: ContractRecurringJobsComponent,
  contract_recurring_invoices: ContractRecurringInvoicesComponent,
  contract_items: ContractItemsComponent,
  asset_variant: AssetViewVariantComponent,
  user_skills: UserSkillsComponent,
  job_tasks: ViewJobTasksComponent,
  resources: ResourceLineItemsComponent,
  job_work_locations: JobViewWorkLocationsComponent,
};
